<template>

<form-container :title="stageTitle">    
    <div class="-card-body">
    <div
        v-for="(type, index) in documentTypes"
        :key="index"
        class="mt-3">
        <h3>{{type.label}}</h3>
        <p>{{type.tip}}</p>

        <b-card no-body>
        <b-tabs card>
          <b-tab title="Uploaded" nav-class="nav-item-no-padding-bottom" :active="allDocumentsByType(type.id).length > 1" :disabled="allDocumentsByType(type.id).length <= 0">
            <b-list-group>
              <b-list-group-item v-for="(itm, idx) in allDocumentsByType(type.id)" :key="'existingDoc_' + idx">{{itm.originalFilename}}</b-list-group-item>
            </b-list-group>
          </b-tab>
          <b-tab title="Upload">
            <doc
              v-model="documents"
              :fileType="type.id"
              :entityRef="formRef"
              :entityType="entityType"
              @status="() => {}">
            </doc>
          </b-tab>
        </b-tabs>
      </b-card>   
    </div>
    </div>
    <form-alert class="mt-3" :show="showSaveMsg && (claimFormSaveMsg && claimFormSaveMsg.length > 0)" :flavour="1" :resellerId="resellerIdAsNumber">{{claimFormSaveMsg}}</form-alert>
    <br /><br />
    <form-button-bar
        :back_button_enable='true'
        :back_button_show='true'
        :back_button_icon_enable='true'
        :back_button_action='() => $router.go(-1)'
        :save_button_enable='true'
        :save_button_show='true'
        :save_button_icon_enable='true'
        :save_button_action='handleSaveClick'
        :next_button_enable='true'
        :next_button_show='true'
        :next_button_icon_enable='true'
        :next_button_action='handleNextClick' />
</form-container>
</template>

<script>

import axios from 'axios'

import doc from '@/components/Upload.vue'

import tigaClaimForm from '@/mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormAlert from '@/components/FormAlert.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

import { mapGetters } from 'vuex';

let baseUrl = process.env.VUE_APP_API_BASE_URL

export default {
  name: 'supportingDocs',
  mixins: [
    tigaClaimForm
  ],
  components: {
    FormContainer,
    FormAlert,
    doc,
    FormButtonBar
  },
  data () {
    return {
      documentTypesIncUpload: [],
       entityType: 1001,
      documents: [],
      formDocuments: [],
      showSaveMsg: false
    }
  },
  beforeMount () {
    this.fetchDocumentTypesV2()
    this.saveClaimForm()
  },
  mounted () {
    console.log("Mounted")
    if (!this.claimformHasPolicyNumber || 
      !this.claimformHasClaimant || 
      !this.claimformHasIncidentType || 
      !this.claimformHasClaimantUKRes ||
      !this.claimformHasClaimantVATReg ||
      !this.claimformHasIncidentDetails ||
      !this.claimformHasGadgets) {
      this.gotoStage1();
    }
    this.documentTypesIncUpload = [ ...this.documentTypes ]
  },
  watch: {
    'documents' (newVal) {
      this.formDocuments = [ ... this.formDocuments, ...this.documents ]
    }
  },
  computed: {
    formRef () { // TODO: Need to pick one and make sure front and back ends use it!!
      if (this.claimForm.formReference) {
        return this.claimForm.formReference
      }

      return this.claimForm.formRef
    },
    message: {
      get () {
        return this.$store.state.obj.message
      },
      set (value) {
        this.$store.commit('updateMessage', value)
      }
    },
    ...mapGetters({
      existingDocuments: 'claimform/claimFormDocuments'
    }),
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    handleNextClick () {
      this.setDocuments([ ...this.formDocuments, ...this.existingDocuments ])
      this.$router.push({ path: '13' })
    },
    handleSaveClick () {
      this.saveClaimForm()
      this.showSaveMsg = true
    },
    existingDocumentsByType(typeId) {
      if (this.existingDocuments && this.existingDocuments.length > 0) {
        return this.existingDocuments.filter(d => d.typeId == typeId)
      }
      return []
    },
    allDocumentsByType(typeId) {
      let allDocuments = [...new Set([...this.existingDocuments, ...this.formDocuments])]
      if (allDocuments && allDocuments.length > 0) {
        return allDocuments.filter(d => d.typeId == typeId)
      }
      return []
    }
  }
}
</script>

<style>

.nav-tabs .nav-item {
  padding-bottom: 0px !important;
}

.nav-tabs .nav-item .nav-link {
    color: #495057;
}

.img-upload {
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.img-upload-body .row {
  border: 0px !important;
}
</style>
